import React, { useEffect, useState } from 'react'
import { FirebaseHelper } from '../../firebase-helper';
import { comment } from '../../utility/comment-utility';
import LikeButtons from '../LikeButtons/LikeButtons';
import './CommentCard.scss'

function CommentCard(props) {
    const [theComment, setTheComment] = useState();

    useEffect(() => {
        setTheComment(props.comment);
    }, []);


    return (theComment &&
        <div className='comment-card'>
            <div className='comment-content'>
                <h4><span>Nickname: </span>{theComment.nickname}</h4>
                <div className='comment'><span>Comment: </span>{theComment.comment}</div>
            </div>
            <div className='comment-buttons'>
                <LikeButtons id={props.id} type="comments" likes={theComment.likes} dislikes={theComment.dislikes} clickAble={true} object={theComment} />
            </div>
        </div>
    )
}

export default CommentCard